export default "__VITE_ASSET__CJ4_FszK__"